import { useSelector } from 'react-redux'
import { selectVsicById } from '../../../common/category/store/slice'
import useGetVsic from '../../../common/category/useGetVsic'
import { Element } from '../../../common/html/element'
import { formatText } from '../../../helpers/value'

export const Industry = ({ data, detailKey }) => {
  useGetVsic()
  const vsicCode = useSelector(selectVsicById(data?.industry?.vsicId, 'code'))

  return (
    <>
      <Element
        elementName="span"
        className="fw600 textUppercase"
        style={{ fontSize: 24, color: '#0553A5' }}
      >
        {formatText(data[detailKey]?.industryName)}
      </Element>
      &nbsp;&nbsp;
      <Element
        elementName="span"
        className="fw600"
        style={{ color: '#3A414B' }}
      >
        (VSIC: {formatText(vsicCode)})
      </Element>
    </>
  )
}
